

import { CREATE_CUSTOMER_PO_DETAILS_GRID_DATA_FAILURE, CREATE_CUSTOMER_PO_DETAILS_GRID_DATA_REQUEST, CREATE_CUSTOMER_PO_DETAILS_GRID_DATA_SUCCESS, CREATE_USER_FORM_CUSTOMER_PO_DETAIL, CUSTOMER_PO_DETAILS_FORM_RESET, DELETE_CUSTOMER_PO_DETAILS_GRID_DATA_FAILURE, DELETE_CUSTOMER_PO_DETAILS_GRID_DATA_REQUEST, FETCH_ARTICLE_NO_DATA_FAILURE, FETCH_ARTICLE_NO_DATA_REQUEST, FETCH_ARTICLE_NO_DATA_SUCCESS, FETCH_CUSTOMER_PO_DETAILS_GRID_DATA_FAILURE, FETCH_CUSTOMER_PO_DETAILS_GRID_DATA_REQUEST, FETCH_CUSTOMER_PO_DETAILS_GRID_DATA_SUCCESS, FETCH_CUSTOMER_PO_DETAILS_LAST_TABLE_ID_FAILURE, FETCH_CUSTOMER_PO_DETAILS_LAST_TABLE_ID_REQUEST, FETCH_CUSTOMER_PO_DETAILS_LAST_TABLE_ID_SUCCESS, FETCH_SINGLE_CUSTOMER_PO_DETAIL_FAILURE, FETCH_SINGLE_CUSTOMER_PO_DETAIL_REQUEST, FETCH_SINGLE_CUSTOMER_PO_DETAIL_SUCCESS, UPDATE_CUSTOMER_PO_DETAILS_GRID_DATA_FAILURE, UPDATE_CUSTOMER_PO_DETAILS_GRID_DATA_REQUEST, UPDATE_CUSTOMER_PO_DETAILS_GRID_DATA_SUCCESS } from "./customerPODetails.actionsType";

export const CUSTOMER_PO_DETAILS = 'customerPODetails';


let initialState = {
    loading: false,
    activeKey: 1,
    customerPODetailData: [],
    detailsId: '',
    customerPODetailForm: {
        fldRate: 0,
        fldQuantity: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldCostPerBag: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldTaxableValue: 0,
        fldGSTValue: 0,
        fldSGSTPercentage: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0,
        fldFKHSNCode: 0
    },
    articleNoData: [],
    customerPOLastTableId: ''
};

export let customerPODetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;


    switch (type) {
        case FETCH_CUSTOMER_PO_DETAILS_GRID_DATA_REQUEST:
        case FETCH_CUSTOMER_PO_DETAILS_LAST_TABLE_ID_REQUEST:
        case CREATE_CUSTOMER_PO_DETAILS_GRID_DATA_REQUEST:
        case UPDATE_CUSTOMER_PO_DETAILS_GRID_DATA_REQUEST:
        case FETCH_SINGLE_CUSTOMER_PO_DETAIL_REQUEST:
        case FETCH_ARTICLE_NO_DATA_REQUEST:
        case DELETE_CUSTOMER_PO_DETAILS_GRID_DATA_REQUEST:
            return {
                ...state,
                loading: true
            };
        case CREATE_USER_FORM_CUSTOMER_PO_DETAIL:
            return {
                ...state,
                loading: false,
                customerPODetailForm: {
                    ...state.customerPODetailForm,
                    [payload.key]: payload.value
                }
            };
        case FETCH_CUSTOMER_PO_DETAILS_GRID_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                customerPODetailData: updatePayload
            };
        case FETCH_CUSTOMER_PO_DETAILS_LAST_TABLE_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                customerPOLastTableId: updatePayload
            };
        case CREATE_CUSTOMER_PO_DETAILS_GRID_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                detailsId: updatePayload
            };
        case UPDATE_CUSTOMER_PO_DETAILS_GRID_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                //detailsId: updatePayload
            };
        case FETCH_SINGLE_CUSTOMER_PO_DETAIL_SUCCESS:
            return {
                ...state,
                loading: false,
                customerPODetailForm: { ...updatePayload }
            };
        case FETCH_ARTICLE_NO_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                articleNoData: updatePayload
            };
        case FETCH_CUSTOMER_PO_DETAILS_GRID_DATA_FAILURE:
        case FETCH_CUSTOMER_PO_DETAILS_LAST_TABLE_ID_FAILURE:
        case CREATE_CUSTOMER_PO_DETAILS_GRID_DATA_FAILURE:
        case UPDATE_CUSTOMER_PO_DETAILS_GRID_DATA_FAILURE:
        case FETCH_SINGLE_CUSTOMER_PO_DETAIL_FAILURE:
        case FETCH_ARTICLE_NO_DATA_FAILURE:
        case DELETE_CUSTOMER_PO_DETAILS_GRID_DATA_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CUSTOMER_PO_DETAILS_FORM_RESET:
            return {
                ...state,
                loading: false,
                customerPODetailForm: {
                    fldArticle: '',
                    fldEANNo: '',
                    fldSize: '',
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldCostPerBag: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldFKHSNCode: 0,
                    fldPerBoxQuantity: 0,
                    fldNoofBoxes: 0,
                },
                articleNoData: [],
            };
        default:
            return state;
    }
}